import { useState } from 'react';
import { postAPI } from '../../services/api.service';
import { toast } from 'react-toastify';

export function useVerifyOtp() {
  const [loading, setLoading] = useState(false);

  const handleVerifyOtp = async (email: string, otp: string) => {
    setLoading(true);
    try {
      const response = await postAPI(`auth/forgot-password/verify-otp`, { email, otp });
      if (response.status === 200) {
        return true;
      } else {
        toast.error(String(response.error || 'Failed to verify OTP'));
        console.error('Failed to verify OTP:', response.error);
        return false;
      }
    } catch (err) {
      console.error('Error verifying OTP:', err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { handleVerifyOtp, loading };
}